import Typography from '@components/common/typography';
import Input from '@components/common/input';
import styles from './styles.module.scss';
import FormField from '@components/form_field';
import { useLocales } from '@hooks/helpers/useLocales';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';

const SecondStepManualLinkBank = () => {
    // const { t } = useTranslation('sections', {
    //     keyPrefix: 'link_card_bank.link_bank.step_2_manual'
    // });
    const { labelLocale, placeholderLocale } = useLocales();
    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <div className={styles.content}>
                <Typography className={styles.title} variant="body2" alignment="center">
                    Please fill in the fields below. Kindly note that using this method will require
                    3-5 business days for your account to be verified and linked
                </Typography>
                <div className={styles.right}>
                    <FormField
                        name="account_name"
                        renderComponent={(props) => (
                            <Input
                                {...props}
                                full
                                label={labelLocale('account_nickname')}
                                placeholder={placeholderLocale('enter_nickname_account')}
                            />
                        )}
                    />
                    <FormField
                        name="transit_number"
                        renderComponent={(props) => (
                            <Input
                                {...props}
                                full
                                label={labelLocale('transit_number')}
                                mask="99999"
                                placeholder={placeholderLocale('enter_transit_number')}
                            />
                        )}
                    />
                    <FormField
                        name="account_number"
                        renderComponent={(props) => (
                            <Input
                                {...props}
                                full
                                label={labelLocale('account_number')}
                                mask="9999999"
                                placeholder={placeholderLocale('enter_account_number')}
                            />
                        )}
                    />
                    <FormField
                        name="bank_number"
                        renderComponent={(props) => (
                            <Input
                                {...props}
                                full
                                onlyNumbers
                                label={labelLocale('bank_number')}
                                placeholder={placeholderLocale('enter_bank_number')}
                            />
                        )}
                    />
                </div>
            </div>
        </motion.div>
    );
};

export default SecondStepManualLinkBank;
